import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import escapeStringRegexp from 'escape-string-regexp';
import _ from 'lodash';
import { Observable, isObservable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
@Pipe({
   name: 'highlightText$',
})
export class HighlightTextPipe implements PipeTransform {
   constructor(protected sanitizer: DomSanitizer) {}

   public transform(
      inputText: Observable<string> | string,
      searchValue: Observable<string[] | string | RegExp> | string[] | string,
      splitSearchValue: boolean = false
   ): Observable<string> {
      const inputText$: Observable<string> = isObservable(inputText) ? inputText : of(inputText);
      const searchValue$: Observable<string[] | string | RegExp> = isObservable(searchValue) ? searchValue : of(searchValue);

      return inputText$.pipe(
         switchMap((value) =>
            searchValue$.pipe(
               map((args) => {
                  const textToHighlight = _.escape(value);
                  if (_.isNil(args)) {
                     return textToHighlight;
                  }

                  let searchRegex: RegExp;

                  if (_.isRegExp(args)) {
                     searchRegex = args;
                  } else {
                     let searchValues: string[];
                     if (_.isString(args) && splitSearchValue) {
                        searchValues = _.split(args, ' ');
                     } else if (_.isString(args)) {
                        searchValues = [args];
                     } else {
                        searchValues = args as string[];
                     }

                     const escapedSearchValues = _(searchValues)
                        .filter((x) => !_.isEmpty(x))
                        .map((x) => _.escape(x))
                        .map((x) => escapeStringRegexp(x))
                        .value();

                     if (_.isEmpty(escapedSearchValues)) {
                        return textToHighlight;
                     }

                     searchRegex = new RegExp(_.join(escapedSearchValues, '|'), 'gi');
                  }

                  const highlightedText = textToHighlight.replace(searchRegex, '<mark>$&</mark>');

                  return this.sanitizer.sanitize(SecurityContext.HTML, highlightedText);
               })
            )
         )
      );
   }
}
